import React, { useState, useEffect } from "react";
import { Select, Tooltip, Button, Typography, Progress } from "antd";
import { CameraOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Text } = Typography;

const Scenario = ({ dataJson, setSelectedId, captureHome }) => {
  const [jsonData, setJsonData] = useState([]);
  const [selectedId, setSelectedIdLocal] = useState(null);
  const [showBar, setShowBar] = useState(false);

  useEffect(() => {
    if (dataJson && dataJson.scenario) {
      setJsonData(dataJson.scenario);
    }
  }, [dataJson]);

  const handleStreetChange = (value) => {
    if (value) {
      setSelectedIdLocal(value);
      setSelectedId(value);
      console.log("selected", value);
      setShowBar(true);
    } else {
      setSelectedId(null);
      setShowBar(false);
    }
  };

  const captureCharts = () => {
    captureHome();
  };

  return (
    <div className="main-cards">
      {/* Scenario Selector */}
      <div className="scenario">
        <Select
          showSearch
          style={{ width: 300, marginBottom: "20px" }}
          placeholder="Seleziona scenario"
          value={selectedId || undefined}
          onChange={handleStreetChange}
          optionFilterProp="children"
        >
          {jsonData.map((s) => (
            <Option key={s.replicaAvg} value={s.replicaAvg}>
              {s.scName || `No name - ${s.replicaAvg}`}
            </Option>
          ))}
        </Select>
      </div>

      {/* Progress Bar */}
      {showBar && jsonData.length > 0 && (
        <div style={{ marginBottom: 30 }}>
          <Tooltip
            title={`${jsonData[0].flowOreAlt[0].mattina}: Mattina, ${jsonData[0].flowOreAlt[0].sera}: Sera`}
            placement="top"
          >
            <Progress
              percent={
                (jsonData[0].flowOreAlt[0].mattina /
                  (jsonData[0].flowOreAlt[0].mattina +
                    jsonData[0].flowOreAlt[0].sera)) *
                100
              }
              strokeColor={{
                from: "#0d261dc9",
                to: "#f7a325",
              }}
              showInfo={false}
              style={{ height: 30 }}
            />
          </Tooltip>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 8,
            }}
          >
            {Object.entries(jsonData[0].flowOreAlt[0]).map(([key]) => (
              <Text key={key} style={{ fontWeight: "bold" }}>
                {key}
              </Text>
            ))}
          </div>
        </div>
      )}

      {/* Capture Button */}
      <div style={{ textAlign: "center", width: "50%" }}>
        <Button
          size="large"
          icon={<CameraOutlined />}
          onClick={captureCharts}
          style={{ borderRadius: 8 }}
        >
          Cattura schermata
        </Button>
      </div>
    </div>
  );
};

export default Scenario;
